import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    buyChannels: [],
    buyChannel: null,
    buy_State: null,
    buyState: [],
    links: null,
    meta: null,
    filter: {
      keyword: null,
      status: null,
    },
    channelOptions: [
      { value: 1, text: 'Dealer' },
      { value: 2, text: 'Distributors' },
      { value: 3, text: 'Online Partner' },
      { value: 4, text: 'Reseller' },
      { value: 5, text: 'Retailers' },
      { value: 6, text: 'Online System Builder' },
      { value: 7, text: 'Physical Store' },
    ],
  },

  mutations: {
    CLEAR_ALL(state) {
      state.buyChannels = [];
      state.buyChannel = null;
    },
    SET_BUY_CHANNELS(state, data) {
      state.buyChannels = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_BUY_CHANNEL(state, data) {
      state.buyChannel = data;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
    SET_BUY_STATE(state, data) {
      state.buyState = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    setBuyChannel({ commit }, data) {
      commit('SET_BUY_CHANNEL', data);
    },

    setBuystate({ commit }, data) {
      commit('SET_BUY_STATE', data);
    },

    find({ commit, state }) {
      let url = `/buy_channels?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('BuyChannel'));
          return response.body;
        })
        .then((response) => {
          commit('SET_BUY_CHANNELS', response);
        });
    },

    findById({ commit }, id) {
      return http(`/buy_channels/${id}`)
        .then((response) => response.body)
        .then(typeAs('BuyChannel'))
        .then((item) => {
          commit('SET_BUY_CHANNEL', item);
        });
    },

    findBuystate({ commit }) {
      return http('/indiastate')
        .then((response) => response.body)
        .then(typeAs('BuyState'))
        .then((response) => {
          commit('SET_BUY_STATE', response.data);
        });
    },

    destroy(_, id) {
      return http(`/buy_channels/${id}`, { method: 'DELETE' })
        .then((response) => response.body);
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/buy_channels/${id}`, { method: 'PUT', data })
        : http('/buy_channels', { method: 'POST', data });

      return request.then((response) => response.body);
    },
  },
};
